var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardAngleBracket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00662 14.8456C1.44253 15.2442 2.14937 15.2442 2.58528 14.8456L9.28301 8.72198C9.71892 8.32343 9.71892 7.67719 9.28301 7.27864L2.58528 1.15503C2.14937 0.756483 1.44253 0.756483 1.00662 1.15503C0.57071 1.55357 0.57071 2.19982 1.00662 2.59836L6.91503 8.00031L1.00662 13.4023C0.57071 13.8008 0.57071 14.447 1.00662 14.8456Z",
    fill: "#545F65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardAngleBracket);
export default __webpack_public_path__ + "static/media/forwardAngleBracket.9b2977e2b58fe8b99b13b7fa9ccc62f8.svg";
export { ForwardRef as ReactComponent };